export interface IPoint {
  id: number;
  x: string;
  y: number;
  planId: number;
}

export class Point implements IPoint {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  id: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  x: string;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  y: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  planId: number;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  draggable: boolean;

  constructor(readonly params: any) {
    Object.keys(params).forEach(index => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this[index] = params[index];
    });

    if (params.draggable === undefined) {
      this.draggable = false;
    }
  }
}
